import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CartRecoveryBanner.css";

const SNAPSHOT_KEY = "hr_cart_snapshot";

/**
 * Gentle cart-recovery reminder (Part 5 — personalisation, not manipulation).
 * Only renders when a saved snapshot exists from a previous visit and the
 * current cart is empty. No countdowns, no scarcity language — both actions
 * are equally easy to take.
 */
const CartRecoveryBanner = ({ cart, onAddToCart }) => {
  const navigate = useNavigate();
  const [snapshot, setSnapshot] = useState(null);

  useEffect(() => {
    if (cart.length > 0) return;
    try {
      const raw = localStorage.getItem(SNAPSHOT_KEY);
      const items = raw ? JSON.parse(raw) : null;
      if (Array.isArray(items) && items.length > 0) setSnapshot(items);
    } catch {
      setSnapshot(null);
    }
  }, [cart]);

  if (!snapshot || cart.length > 0) return null;

  const itemCount = snapshot.reduce((sum, i) => sum + (i.qty || 1), 0);

  const handleRestore = () => {
    snapshot.forEach((item) => {
      onAddToCart(item, item.qty || 1);
    });
    localStorage.removeItem(SNAPSHOT_KEY);
    setSnapshot(null);
    navigate("/cart");
  };

  const handleDismiss = () => {
    localStorage.removeItem(SNAPSHOT_KEY);
    setSnapshot(null);
  };

  return (
    <div className="cart-recovery-banner">
      <p className="crb-text">
        You left {itemCount} item{itemCount !== 1 ? "s" : ""} in your selections — pick up where you left off?
      </p>
      <div className="crb-actions">
        <button className="crb-btn crb-btn-dismiss" onClick={handleDismiss}>Not now</button>
        <button className="crb-btn crb-btn-restore" onClick={handleRestore}>View saved items</button>
      </div>
    </div>
  );
};

export default CartRecoveryBanner;
